import { Box, Divider, Grid, Paper, TextField, Typography } from '@material-ui/core'
import React, { useMemo } from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router'
import ClientProfilesView from '../../components/ClientProfilesView'
import { getClientProfiles, getCoaching } from '../../utils/api'

const CoachingHistory = () => {
    const { id, clientId } = useParams<{ id: string, clientId: string }>()
    const { data: coaching } = useQuery(['getcoaching', id, clientId], () => getCoaching(id).then(res => res.data))
    const { data: clientProfiles } = useQuery(['getclientprofile', clientId], () => getClientProfiles(clientId).then(res => res.data))

    const goals = useMemo(() => {
        if (coaching) {
            if (coaching.coaching.goals) {
                const resultGoals = coaching.coaching.goals.split(',')
                return resultGoals
            }
        }
        return []
    }, [coaching])

    const sessions = useMemo(() => {
        if (coaching) {
            if (coaching.sessions) {
                return coaching.sessions.sort((s: CoachingSession, s1: CoachingSession) => s.level - s1.level)
            }
        }
        return []
    }, [coaching])

    return <Box>
        {clientProfiles && <ClientProfilesView profiles={clientProfiles} hideDetailButtton />}
        <Paper style={{ marginTop: '20px' }}>
            <Box p={3}>
                <Grid container spacing={3}>
                    <Grid item xs={9}>
                        <Box>
                            <Typography align="center">教练目标</Typography>
                            {goals.map((goal: string, index: number) =>
                                <TextField disabled key={index} value={goal} label={`目标${index + 1}`} style={{ margin: '8px 0' }} fullWidth />
                            )}
                        </Box>
                        <Box>
                            {sessions.map((session: CoachingSession) => <Box border="1px solid #e1e1e1" p={1} mb={2}>
                                <Box>第{session.level}次教练</Box>
                                <Box>
                                    {session?.weeklyObjectives.map((obj, index) => <Box >
                                        <Box p={2}>
                                            <Typography display="inline">计划{index + 1}: {obj.objectives}</Typography>
                                            <Typography display="inline" style={{ marginLeft: '10px' }} variant="body2" color="textSecondary">{obj.complate_quality && `(完成程度${obj.complete_level}，完成质量:${obj.complate_quality})`}</Typography>
                                        </Box>
                                    </Box>)}
                                </Box>
                                <Box p={2} fontSize="14px">可能的阻碍与相应措施:<Typography style={{ marginLeft: '10px' }} variant="body2" color="textSecondary" display="inline">{session.hinder_and_measures}</Typography></Box>
                                <Box p={2} fontSize="14px">教练评价:<Typography style={{ marginLeft: '10px' }} variant="body2" color="textSecondary" display="inline">{session.reviews}</Typography></Box>
                            </Box>)}
                        </Box>
                    </Grid>
                    <Grid xs={3} item container >
                        <Grid item xs={1}>
                            <Divider orientation="vertical" />
                        </Grid>
                        <Grid item xs={11}>
                            <Box display="flex" flexDirection="column" height="100%" >
                                <Box mb={2} display="flex" alignItems="center"> <Typography>教练笔记</Typography></Box>
                                <Box height="100%"><TextField value={coaching ? coaching.notes : ''} disabled variant="outlined" multiline fullWidth style={{ height: '100%' }} /></Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    </Box>
}

export default CoachingHistory